import { pdfCommissions, pdfLevels, pdfTraining1 } from '@/config'

const contacts = {
  phone2: '+225 21 22 61 61',
  whatsapp1: ''
}

const referralLink = "https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fci%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.ci%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral"

const dashboardGetUpdatedItems = [
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    link: 'https://www.facebook.com/groups/846814258778300/',
    newPage: true
  },
  {
    disabled: true,
    img: 'img/dashboard/comingSoon.svg',
    title: {
      key: 'dashboard.media.jumia_blog'
    },
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
  {
    img: 'img/dashboard/contact-form.svg',
    title: {
      text: 'Une reclamation?'
    },
    subtitle: {
      text: 'Contactez nous via ce formulaire',
      isKey: false
    },
    link: 'https://docs.google.com/forms/d/1RuqzJqQOA8A5eVhPpIq5FX40YvJrW-6bCfo_22Y5bys/edit?usp=forms_home&ths=true',
    newPage: true
  },
  {
    img: 'img/dashboard/whatsapp.svg',
    title: {
      text: 'Contactez nous via whatsapp'
    },
    subtitle: {
      text: '+2250769928407',
      isKey: false
    },
    link: 'https://wa.me/+2250769928407',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      text: 'Rejoignez le groupe Facebook Jforce'
    },
    link: 'https://urlz.fr/nyLG',
    newPage: true
  }
]

const dashboardOtherItems = [
  {
    disabled: false,
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      key: 'dashboard.other.commission_grid'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/medal.svg',
    title: {
      key: 'dashboard.other.levels'
    },
    link: pdfLevels,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'Formation'
    },
    link: pdfTraining1,
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
